<template>
    <div class="container">
        <div class="section">
            <HeaderCom></HeaderCom>
        </div>
        <div class="container1">
            <div class="section section1">
                <h2>用户协议</h2>
                <p>感谢您选择“AiChina”，请在使用过程中遵守本服务协议。在接受协议之前，请务必仔细阅读本服务协议的全部内容。如果您不同意本服务协议内容，请不要使用我们提供的服务。您的使用行为将视为对本服务协议的接受，并同意接受其中各项协议的约束。</p>

                <h3>服务内容</h3>
                <p>本协议中服务指的是“AiChina”，向您提供网络加速服务以及相关的技术支持服务。用户有权在服务期限内合法使用相关产品（仅限“外贸海淘/学术研究/资料检索/开发测试”等合法用途）</p>

                <h3>用户义务</h3>
                <p>用户在使用本产品过程中，不得实施违反本国法律的行为或发布违反本国法律的内容，同时不得违反线路服务器所在地区国家的相关法律。</p>
                <p>如果使用存在以下禁止行为，AiChina有权在不发出警告的情况下，停用帐号或取消该帐号的服务且不退款。对于违法行为，将配合执法机关追责！</p>
                <p>不得下载或传播侵犯知识产权相关内容</p>
                <p>不得下载 BT 种子，或使用 eMule，迅雷，FlashGet 等 P2P 工具</p>
                <p>不得用于“注册机/发贴机/垃圾邮件/群发外链/网络攻击/网络诈骗”等用途</p>
                <p>不得发布任何非法、威胁、诽谤、反动、赌博、淫秽、色情信息或其它违法信息</p>
                <p>不得利用本系统可能存在漏洞以各种形式为自己及他人牟利</p>

                <h3>不可抗力</h3>
                <p>不可抗力意外事件是指不能预见、不能克服的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等，以及社会事件如战争、动乱、政府行为、电信主干线路中断、黑客、网路堵塞、电信部门技术调整等。遭受不可抗力、意外事件的一方不承担责任。</p>

                <h3>AiChina服务协议重要须知：</h3>
                <p>AiChina运营者在此特别提醒用户认真阅读本协议条款(未成年人应在监护人陪同下审阅),您有权接受或不接受本《协议》。除非您接受本《协议》条款,否则您无权下载、安装或使用本软件及其相关服务。您的安装使用行为将视为对本《协议》的接受,并同意接受本《协议》各项条款的约束。</p>
                <p>本《协议》描述AiChina与您之间关于AiChina许可使用及相关方面的权利义务。“用户”或“您”是指通过AiChina提供的获取软件授权和号码注册的途径获得软件产品及号码授权许可的个人或单一实体。</p>

                <h3>知识产权</h3>
                <p>根据这些条款和条件，我们授予您有限的、非排他的、个人的、不可转让的、不可再许可的许可，以：</p>
                <p>下载和使用"AiChina"软件的副本；</p>
                <p>使用"AiChina"服务，包括但不限于在"AiChina"软件或我们的网站上或通过我们的网站提供的产品和服务。根据"AiChina"服务，本协议未授予您任何其他权利或许可。本文提供的许可在终止之前一直有效。如果您不遵守这些条款，该许可将自动终止。</p>
                <p>"AiChina"服务（包括但不限于"AiChina"软件，移动应用程序和所有其他项目）由"AiChina"拥有并拥有版权，并且在全球范围内受到保护。我们保留对"AiChina"服务及其任何部分的权利，所有权和利益，包括但不限于所有版权，商标，服务标记，商业秘密和其他知识产权。您不得采取任何行动来危害，限制或以任何方式干扰我们对"AiChina"服务的所有权和权利。除非另有说明，否则保留所有权利。</p>
                
                <h3>禁止事项</h3>
                <p>用户应在遵守法律及本协议的前提下依本《协议》约定使用本软件。用户不得实施包括但不限于下列行为:</p>
                <p>(1)擅自删除本软件及其他副本上所有关于版权的信息、内容; </p>
<p>(2)擅自对本软件进行反向工程、反向汇编、反向编译等; </p>
<p>(3)对于本软件相关信息等,擅自使用、复制、修改、链接、转载、汇编、发表、出版,建立镜像站点、擅自借助软件发展与之有关的衍生产品、作品、服务等。 </p>
<p>(4)利用本软件发表、传送、传播、储存违反国家法律、危害国家安全、祖国统一、社会稳定的内容,或任何不当的、侮辱诽谤的、淫秽的、暴力的及任何违反国家法律法规政策的内容。 </p>
<p>(5)利用本软件发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容。 </p>
<p>(6)使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用本软件获得的图像或相片的资料或信息。 </p>
<p>(7)利用本软件进行任何危害计算机网络安全的行为,包括但不限于:使用未经许可的数据或进入未经许可的服务器/账户;未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息;未经许可,企图探查、扫描、测试本软件系统或网络的弱点或其它实施破坏网络安全的行为;企图干涉、破坏本软件系统或网站的正常运行,故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为;伪造 TCP/IP 数据包名称或部分名称。</p>

                <h3>免责声明</h3>
                <p>我们将努力防止网站和服务受到干扰。但是，这些内容是按“原样”和“可用”的基础提供的，我们不保证（明示或暗示）通过本网站或服务提供的任何材料或信息的准确性，或它们对以下内容的适用性：任何特定目的。我们明确否认任何形式的担保，无论是明示的还是暗示的，包括但不限于适销性或针对特定目的的适用性或非侵权的担保。我们不保证本服务将满足您的要求，也不保证其不间断，及时，安全或无错误，也不对任何缺陷进行纠正。您承认自己承担风险和酌情权访问网站和服务。</p>
                <p>"AiChina"保留调查我们认为违反这些条款的问题的权利。我们可能会（但无义务）在不另行通知的情况下，自行决定，以任何方式删除，阻止，过滤或限制我们认为是实际或潜在违反本条款所规定限制的任何材料或信息，以及任何其他可能使"AiChina"或我们的客户承担责任的活动。"AiChina"对我们未能防止此类材料或信息通过“服务”和/或进入您的计算设备的任何故障不承担任何责任。</p>

                <h3>适用法律</h3>
                <p>本协议应受中国法律的管辖并根据其解释，但其法律冲突规则除外。</p>

                <h3>联系我们</h3>
                <p>如果您对我们的服务条款有投诉、建议、疑问，您可以将问题发送至（suport@aichina.com）我们将尽快审核所涉问题，并在验证您的用户身份后的十五个工作日内回复。</p>
                <br/><br/>
                <div>更新日期：2022年01月06日</div>
                <div>生效日期：2022年01月06日</div>
                <div>OPENSYNTH LTD.</div>
            </div>
        </div>
        <FooterCom></FooterCom>
    </div>
</template>

<script>
import HeaderCom from "@/components/header"
import FooterCom from "@/components/footer"
export default {
    name:"App",
    components:{
        HeaderCom,
        FooterCom
    },
}
</script>

<style>
.section{width:1320px;margin:0 auto;}
.container{width:100%;min-width: 1320px;}
.container1{width:100%;min-height:1440px;background: #F8F9FC;padding-top:30px;padding-bottom: 66px;text-align:justify;}
.section1{width: 1200px;
min-height: 1186px;
padding:60px 55px;
background: #FFFFFF;
border-radius: 20px;;}
.section1 h2{font-size:24px;}
.section1 p{color: #545454;text-indent:48px;font-size:14px;line-height:28px;margin:18px 0;}
.section1>div{color: #545454;}
.section1 h3{font-size:20px;margin-bottom:18px;font-weight: normal;}
</style>